import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { addNetwork } from '../../store/SocialMedia';

const Wrapper = styled.div`
  width: 100%;
`;

const Icon = styled.img`
  width: auto;
  height: 22px;
  margin: 0 25.2px 0 0;
  cursor: pointer;
`;

class SocialMedia extends React.PureComponent {
  render() {
    const { socialNetworks, className } = this.props;

    return (
      <Wrapper className={className}>
        {socialNetworks.map(network => (
          <Icon
            key={network.order}
            src={network.img}
            alt={network.name}
            onClick={() => window.open(network.url, '_blank')}
          />
        ))}
      </Wrapper>
    );
  }
}

SocialMedia.defaultProps = {
  socialNetworks: [],
  className: ''
};

SocialMedia.propTypes = {
  socialNetworks: PropTypes.array,
  className: PropTypes.string
};

const mapStateToProps = state => ({
  socialNetworks: state.socialNetworks
});

const mapDispatchToProps = dispatch => ({
  createNewNetwork(newNetwork) {
    dispatch(addNetwork(newNetwork));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SocialMedia);



// WEBPACK FOOTER //
// ./src/components/SocialMedia/index.jsx